import * as actionTypes from "../actionTypes";
const initialState = {
  error: null,
  onboardingData: null,
  onboardingGetLoading: false,
  onboardingGetStatus: "idle",
  onboardingGetError: null,
  onboardingUpdateLoading: false,
  onboardingUpdateStatus: "idle",
  onboardingUpdateError: null,
  updatedOnboardingResponse: null,
};
const profileReducer = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actionTypes.GET_PROFILE:
      return {
        ...state,
        error:null,
        profile:null
      };
    case actionTypes.GET_PROFILE_SUCCESS:
      return {
        ...state,
        profile: payload,
      };
    case actionTypes.GET_PROFILE_ERROR:
      return {
        ...state,
      };
    case actionTypes.ONBOARDING_GET:
      return {
        ...state,
        onboardingGetLoading: true,
        onboardingGetStatus: "loading",
        onboardingGetError: null,
      };
    case actionTypes.ONBOARDING_GET_SUCCESS:
      return {
        ...state,
        onboardingData: payload,
        onboardingGetLoading: false,
        onboardingGetStatus: "success",
        onboardingGetError: null,
      };
    case actionTypes.ONBOARDING_GET_FAIL:
      return {
        ...state,
        onboardingGetLoading: false,
        onboardingGetStatus: "error",
        onboardingGetError: payload?.error || error || null,
      };
    case actionTypes.ONBOARDING_UPDATE:
      return {
        ...state,
        onboardingUpdateLoading: true,
        onboardingUpdateStatus: "loading",
        onboardingUpdateError: null,
        updatedOnboardingResponse: null,
      };
    case actionTypes.ONBOARDING_UPDATE_SUCCESS:
      return {
        ...state,
        onboardingData:
          payload && typeof payload === "object"
            ? { ...(state.onboardingData || {}), ...payload }
            : payload,
        updatedOnboardingResponse: payload,
        onboardingUpdateLoading: false,
        onboardingUpdateStatus: "success",
        onboardingUpdateError: null,
      };
    case actionTypes.ONBOARDING_UPDATE_FAIL:
      return {
        ...state,
        onboardingUpdateLoading: false,
        onboardingUpdateStatus: "error",
        onboardingUpdateError: payload?.error || error || null,
      };
    case actionTypes.SET_PROFILE:
      return {
        ...state,
        error:null,
        setProfileSuccess:null
      };
    case actionTypes.SET_PROFILE_SUCCESS:
      return {
        ...state,
        setProfileSuccess: payload,
      };
    case actionTypes.SET_PROFILE_ERROR:
          console.log(error);
      
      return {
        ...state,
        error:error
      };

    case actionTypes.SET_PROFILE_PASSWORD:
      return {
        ...state,
        profilePasswordError: '',
        profilePasswordSuccess: false,
      };
    case actionTypes.SET_PROFILE_PASSWORD_SUCCESS:
      return {
        ...state,
        profilePasswordError: '',
        profilePasswordSuccess: true,
      };
    case actionTypes.SET_PROFILE_PASSWORD_ERROR:
      return {
        ...state,
        profilePasswordError: error,
        profilePasswordSuccess: false,
      };
    default:
      return state;
  }
};
export default profileReducer;
